// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2hxTp","content":"LoadingAlert_content__1Ouxp"};